import type { Accent, SoundId } from '../types/anna';

export const dayparts = [
  { id: 'ochtend', label: 'Ochtend', hours: '06:00–10:00', glow: '#2BA9B5', note: 'Koel blauwgroen. Helder en wakker.' },
  { id: 'focus', label: 'Focuswerk', hours: 'Overdag', glow: '#7D8798', note: 'Neutraal. Niets trekt aandacht.' },
  { id: 'avond', label: 'Avond', hours: '18:00–22:30', glow: '#E0954A', note: 'Warm amber. Trager tempo.' },
  { id: 'nacht', label: 'Nacht', hours: '22:30–06:00', glow: '#1C2230', note: 'Bijna zwart. Alleen een gedimde klok.' },
];

export const accentProposals: { id: Accent; name: string; hex: string; note: string }[] = [
  {
    id: 'teal',
    name: 'Lichtend teal',
    hex: '#4FE3D0',
    note: 'Koel en helder, leest op elk uur als "aanwezig". Blijft goed los van amber, dat is voor waarschuwingen en Niet storen. Aanbevolen.',
  },
  {
    id: 'gold',
    name: 'Warm goud',
    hex: '#E9C46A',
    note: 'Huiselijk en warm, mooi in de avond. Ligt dicht bij amber, dus waarschuwingen hebben extra onderscheid in vorm nodig.',
  },
];

export const typeScale = [
  {
    role: 'Ondertitel wandtablet',
    spec: 'Outfit Light · 36 px (bereik 32–40)',
    sample: 'Je eerste afspraak is om 10:00.',
    className: 'font-display text-[36px] font-light leading-tight',
  },
  {
    role: 'Body wandtablet · minimum',
    spec: 'Inter Regular · 22 px',
    sample: 'Bezorger met een pakket. Open zelf via de deurbel-app.',
    className: 'text-[22px] leading-snug',
  },
  {
    role: 'Body telefoon · minimum',
    spec: 'Inter Regular · 16 px',
    sample: '3 dingen wachten op je · Code test nog',
    className: 'text-[16px]',
  },
  {
    role: 'Meta · alleen bureauscherm en Beheer',
    spec: 'Inter Medium · 13 px',
    sample: 'lokaal · stap 3/5 · 00:42',
    className: 'text-[13px] font-medium',
  },
];

export const contrastTokens = [
  { name: 'ink', hex: '#EEF2F6', use: 'Primaire tekst' },
  { name: 'ink-soft', hex: '#C9D2DD', use: 'Secundaire tekst' },
  { name: 'ink-muted', hex: '#9AA6B5', use: 'Meta, labels' },
];

export const contrastSurfaces = [
  { name: 'Achtergrond', hex: '#0A0D12' },
  { name: 'Glas', hex: '#1A202B' },
];

export const sounds: { id: SoundId; name: string; when: string }[] = [
  { id: 'meldt', name: 'Zachte chime', when: 'Anna meldt iets uit zichzelf' },
  { id: 'geweigerd', name: 'Lage toon', when: 'Geweigerd, bijvoorbeeld een slot via een onbekende stem' },
  { id: 'klaar', name: 'Korte stijgende toon', when: 'Klaar: taak afgerond of goedkeuring verwerkt' },
];

export const forbidden = [
  'Neon HUD-rommel en zwevende cijfers',
  'Nep-zeshoekrasters en scanlines',
  'Willekeurige getallen of grafieken zonder betekenis',
  'Rood/blauw "hacker"-palet',
  'Iron Man rood-goud',
  'Knipperend rood, behalve bij echte veiligheidsalarmen',
];
